const STRINGS = {
  MENU_ITEMS: 'res_panel.menu_items',
  ALLERGENS: 'res_panel.allergens',
  EXTRAS: 'res_panel.extras',
  VARIANTS: 'res_panel.variants',
  FINANCE: 'res_panel.finance',
  REVIEW: 'res_panel.reviews',
  EVENTS: 'res_panel.events',
  FAQ: 'res_panel.faq',
  JOBS: 'res_panel.jobs',
  SUBSCRIPTION: 'res_panel.subscriptions',
  COMMON: 'common',
  PROFILE: 'storefront.profile',
  SHARE: 'res_panel.share',
  BANNER_NOTIFICATION: 'res_panel.banner_notifications',
  COUPONS: 'res_panel.coupons',
  SEARCH: 'storefront.search',
  OWNER: 'res_panel.store_management.owner',
  WORKING_HOURS: 'res_panel.store_management.working_hours',
  ERRORS: 'form_validations',
};

export const COMMON = 'common';

export const STOREFRONT = {
  STORE_PROFILE: 'storefront.store_profile',
  ORDERS: 'storefront.orders',
  JOBS: 'storefront.jobs',
  EVENTS: 'storefront.events',
  ADDRESS: 'storefront.address',
  CHECKOUT: 'storefront.checkout',
  VENDOR: 'vendor_page',
  REVIEWS: 'storefront.reviews',
  SEARCH: 'storefront.search',
  MENU: 'storefront.menu',
  HOME: 'storefront.home',
  FAVORITES: 'storefront.favorites',
};

export const BUSINESS = {
  EMPLOYEES: 'res_panel.employees',
  DRIVERS: 'res_panel.drivers',
  LIVE_ORDERS: 'res_panel.live_orders',
  ORDERS: 'res_panel.orders',
};

export const TOAST = {
  CHECKOUT: 'toast.checkout',
  EMPLOYEE: 'toast.employee',
  BANNER: 'toast.banner_notification',
};

export default STRINGS;
